import * as KfDesginer from "../index";

var globalObject = (typeof global !== 'undefined') ? global : ((typeof window !== 'undefined') ? window : undefined);
if (typeof globalObject !== "undefined") {
    (<any>globalObject).Kingfisher = (<any>globalObject).BABYLON || {};
    (<any>globalObject).Kingfisher.kfDesginer = KfDesginer;
}

export * from "../index";